import axios from 'axios';
import {
    GET_CATEGORY_WISE_SERVICES, CATEGORY_WISE_SERVICE_ERROR
} from './types';
import { base_url } from './constants';

axios.defaults.baseURL = base_url;


//GET category wise services
export const getCategoryWiseServices = () => async dispatch => {
    try {
        const res = await axios.get('/api/cat_wise_services/');
        console.log(res.data);
        dispatch({ type: GET_CATEGORY_WISE_SERVICES, payload: res.data })
    } catch (err) {
        console.log(err);
        dispatch({
            type: CATEGORY_WISE_SERVICE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });
    }
}